import { STATUS_CHIP } from "constants";

export const STATUS_HISTORY_TABLE_COLUMNS = [
  "Batch ID",
  "Upload Type (SO / FG)",
  "File Name",
  "Uploaded By",
  "Uploaded On",
  "Batch Status",
  "Total Records",
  "Success Count",
  "Failed Count",
  "Skipped Count",
  "",
];

export const UPLOAD_NAME = {
  ALL: "ALL",
  OTHER: "OTHER",
};

export const UPLOAD_NAME_TONE_PALETTE = [
  "success",
  "info",
  "warning",
  "neutral",
];

export const UPLOADED_BY_ALL_OPTION = "ALL";

export const REQUEST_STATUS = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  PROCESSING: "PROCESSING",
  PENDING: "PENDING",
  UPLOADED: "UPLOADED",
  PARTIAL: "PARTIAL",
};

export const REQUEST_STATUS_CHIP_CONFIG = {
  [REQUEST_STATUS.SUCCESS]: { label: "Success", type: STATUS_CHIP?.success },
  [REQUEST_STATUS.PENDING]: { label: "Pending", type: STATUS_CHIP?.warning },
  [REQUEST_STATUS.PARTIAL]: { label: "Partial", type: STATUS_CHIP?.attention },
  [REQUEST_STATUS.UPLOADED]: { label: "Uploaded", type: STATUS_CHIP?.success },
  [REQUEST_STATUS.FAILED]: { label: "Failed", type: STATUS_CHIP?.error },
  [REQUEST_STATUS.PROCESSING]: { label: "Processing", type: STATUS_CHIP?.info },
};

export const DEFAULT_PAGE = 0;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

export const DEFAULT_FILTER_VALUES = {
  search: "",
  uploadName: UPLOAD_NAME.ALL,
  uploadedBy: UPLOADED_BY_ALL_OPTION,
  uploadedFrom: "",
  uploadedTo: "",
};

export const FROM_DATE_ERROR = "From date should not be greater than to date";
export const TO_DATE_ERROR = "To date should not be less than from date";

export const NO_DATA_MESSAGE = "File upload history is not available";

export const FETCH_HISTORY_API_URL =
  "/joms/api/external/v1/file-upload/history";
export const FETCH_USERS_API_URL =
  "/joms/api/external/v1/file-upload/users-and-file-types";
